const LOAD_DETAIL_PARTNERS           = 'LOAD_DETAIL_PARTNERS'
const LOAD_DETAIL_PARTNERS_SUCCESS   = 'LOAD_DETAIL_PARTNERS_SUCCESS'
const LOAD_DETAIL_PARTNERS_FAILED    = 'LOAD_DETAIL_PARTNERS_FAILED'
const UNMOUNT_DETAIL_PARTNERS        = 'UNMOUNT_DETAIL_PARTNERS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const partnersDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_PARTNERS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_PARTNERS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_PARTNERS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_PARTNERS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default partnersDetailReducer;